import React, { useEffect } from "react";
import "./App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import Impact from "./pages/Impact";
import Awards from "./pages/Awards";
import Contact from "./pages/Contact";
import Services from "./pages/Services";
import Feedback from "./pages/Feedback";
import Admin from "./pages/Admin";
import Header from "./components/Header";
import Footer from "./components/Footer";
import { Toaster } from "./components/ui/sonner";
import { initAnalytics, trackPageView } from "./utils/analytics";

// Component to track page views on route changes
function AnalyticsTracker() {
  const location = useLocation();
  
  useEffect(() => {
    trackPageView();
  }, [location]);
  
  return null;
}

// Reset scroll position to top on every route change
function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  useEffect(() => {
    // Initialize analytics on app load
    initAnalytics();
  }, []);
  
  return (
    <div className="App bg-white min-h-screen">
      <BrowserRouter>
        <ScrollToTop />
        <AnalyticsTracker />
        <Header />
        <main className="pt-20">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/impact" element={<Impact />} />
            <Route path="/awards" element={<Awards />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/services" element={<Services />} />
            <Route path="/feedback" element={<Feedback />} />
            <Route path="/admin" element={<Admin />} />
          </Routes>
        </main>
        <Footer />
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
